// Country name → ISO 3166-1 alpha-2 code (for flagcdn.com)
export const COUNTRIES = {
  "Afghanistan":"af","Albania":"al","Algeria":"dz","Angola":"ao","Argentina":"ar",
  "Armenia":"am","Australia":"au","Austria":"at","Azerbaijan":"az","Bahamas":"bs",
  "Bahrain":"bh","Bangladesh":"bd","Barbados":"bb","Belarus":"by","Belgium":"be",
  "Belize":"bz","Benin":"bj","Bhutan":"bt","Bolivia":"bo","Bosnia":"ba",
  "Botswana":"bw","Brazil":"br","Bulgaria":"bg","Burkina Faso":"bf","Burundi":"bi",
  "Cambodia":"kh","Cameroon":"cm","Canada":"ca","Chad":"td","Chile":"cl",
  "China":"cn","Colombia":"co","Congo":"cg","Costa Rica":"cr","Croatia":"hr",
  "Cuba":"cu","Cyprus":"cy","Czech Republic":"cz","DR Congo":"cd","Denmark":"dk",
  "Djibouti":"dj","Dominican Republic":"do","Ecuador":"ec","Egypt":"eg",
  "El Salvador":"sv","Eritrea":"er","Estonia":"ee","Ethiopia":"et","Fiji":"fj",
  "Finland":"fi","France":"fr","Gabon":"ga","Gambia":"gm","Georgia":"ge",
  "Germany":"de","Ghana":"gh","Greece":"gr","Guatemala":"gt","Guinea":"gn",
  "Guyana":"gy","Haiti":"ht","Honduras":"hn","Hungary":"hu","Iceland":"is",
  "India":"in","Indonesia":"id","Iran":"ir","Iraq":"iq","Ireland":"ie",
  "Israel":"il","Italy":"it","Ivory Coast":"ci","Jamaica":"jm","Japan":"jp",
  "Jordan":"jo","Kazakhstan":"kz","Kenya":"ke","Kosovo":"xk","Kuwait":"kw",
  "Kyrgyzstan":"kg","Laos":"la","Latvia":"lv","Lebanon":"lb","Lesotho":"ls",
  "Liberia":"lr","Libya":"ly","Lithuania":"lt","Luxembourg":"lu","Madagascar":"mg",
  "Malawi":"mw","Malaysia":"my","Maldives":"mv","Mali":"ml","Mauritania":"mr",
  "Mauritius":"mu","Mexico":"mx","Moldova":"md","Mongolia":"mn","Montenegro":"me",
  "Morocco":"ma","Mozambique":"mz","Myanmar":"mm","Namibia":"na","Nepal":"np",
  "Netherlands":"nl","New Zealand":"nz","Nicaragua":"ni","Niger":"ne",
  "Nigeria":"ng","North Macedonia":"mk","Norway":"no","Oman":"om","Pakistan":"pk",
  "Palestine":"ps","Panama":"pa","Papua New Guinea":"pg","Paraguay":"py",
  "Peru":"pe","Philippines":"ph","Poland":"pl","Portugal":"pt","Qatar":"qa",
  "Romania":"ro","Russia":"ru","Rwanda":"rw","Saudi Arabia":"sa","Senegal":"sn",
  "Serbia":"rs","Sierra Leone":"sl","Singapore":"sg","Slovakia":"sk",
  "Slovenia":"si","Somalia":"so","South Africa":"za","South Korea":"kr",
  "South Sudan":"ss","Spain":"es","Sri Lanka":"lk","Sudan":"sd","Suriname":"sr",
  "Sweden":"se","Switzerland":"ch","Syria":"sy","Taiwan":"tw","Tajikistan":"tj",
  "Tanzania":"tz","Thailand":"th","Togo":"tg","Trinidad":"tt","Tunisia":"tn",
  "Turkey":"tr","Turkmenistan":"tm","UAE":"ae","USA":"us","Uganda":"ug",
  "Ukraine":"ua","United Kingdom":"gb","Uruguay":"uy","Uzbekistan":"uz",
  "Venezuela":"ve","Vietnam":"vn","Yemen":"ye","Zambia":"zm","Zimbabwe":"zw"
};

export const COUNTRY_LIST = Object.keys(COUNTRIES).sort();

export function getFlagUrl(name) {
  const iso = COUNTRIES[name];
  if (!iso || iso === 'xx') return null;
  return `https://flagcdn.com/w40/${iso}.png`;
}
